import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { directoryPages } from '../../data/pages';
export function TopicNavCards() {
  return <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-173" data-mp="2bahq9ad21m8w">
      {directoryPages.map((page, index) => <Link key={page.path} to={page.path} className="group flex flex-col rounded-xl border border-slate-200 bg-white p-7 transition-colors duration-200 hover:border-brandgreen/50" data-id="element-174" data-mp="26cq1uqbmci9g" data-mpi={index}>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-navy text-xs font-semibold text-white" data-id="element-175" data-mp="2z0u8be20kzd7">
            {index + 1}
          </span>
          <h3 className="mt-5 font-heading text-base font-semibold text-navy" data-id="element-176" data-mp="2pbapg8eax5ic">{page.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-charcoal" data-id="element-177" data-mp="3mqg9g71y5onu">{page.description}</p>
          <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brandgreen" data-id="element-178" data-mp="3hzg88plsokfj">
            Explore
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-179" data-mp="3rc18qdke0arp" />
          </span>
        </Link>)}
    </div>;
}